import type * as Types from '../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CompanyReportsQueryVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type CompanyReportsQueryPage = { readonly __typename?: 'RootQueryType', readonly currentUser?: { readonly __typename?: 'AccountsUser', readonly id: string, readonly company?: { readonly __typename?: 'AccountsCompany', readonly id: string, readonly name: string } | null, readonly projectReports?: ReadonlyArray<{ readonly __typename?: 'ProjectReport', readonly id: string, readonly periodStart: string, readonly periodEnd: string, readonly status: Types.ProjectReportStatus, readonly generatedAt?: string | null, readonly errorReason?: Types.ProjectReportErrorReason | null, readonly reportData?: { readonly __typename?: 'ProjectReportData', readonly meta: { readonly __typename?: 'ProjectReportMeta', readonly adSystem: Types.OauthProvider }, readonly project: { readonly __typename?: 'ProjectReportProject', readonly score?: number | null, readonly risk?: string | number | null, readonly riskDailySpend?: string | number | null } } | null }> | null } | null };


export const CompanyReportsDocument = gql`
    query CompanyReports($companyId: ID!, $limit: Int) {
  currentUser {
    id
    company(id: $companyId) {
      id
      name
    }
    projectReports(companyId: $companyId, limit: $limit) {
      id
      periodStart
      periodEnd
      status
      generatedAt
      errorReason
      reportData {
        meta {
          adSystem
        }
        project {
          score
          risk
          riskDailySpend
        }
      }
    }
  }
}
    `;

/**
 * __useCompanyReportsQuery__
 *
 * To run a query within a React component, call `useCompanyReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyReportsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useCompanyReportsQuery(baseOptions: Apollo.QueryHookOptions<CompanyReportsQueryPage, CompanyReportsQueryVariables> & ({ variables: CompanyReportsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyReportsQueryPage, CompanyReportsQueryVariables>(CompanyReportsDocument, options);
      }
export function useCompanyReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyReportsQueryPage, CompanyReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyReportsQueryPage, CompanyReportsQueryVariables>(CompanyReportsDocument, options);
        }
export function useCompanyReportsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompanyReportsQueryPage, CompanyReportsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompanyReportsQueryPage, CompanyReportsQueryVariables>(CompanyReportsDocument, options);
        }
export type CompanyReportsQueryHookResult = ReturnType<typeof useCompanyReportsQuery>;
export type CompanyReportsLazyQueryHookResult = ReturnType<typeof useCompanyReportsLazyQuery>;
export type CompanyReportsSuspenseQueryHookResult = ReturnType<typeof useCompanyReportsSuspenseQuery>;
export type CompanyReportsQueryResult = Apollo.QueryResult<CompanyReportsQueryPage, CompanyReportsQueryVariables>;